import React, { useState, useEffect } from "react";
import api from "../api/axios";
import { FaTimes } from "react-icons/fa";
import UiText from './UiText';

export default function EditCustomerModal({ customer, companies, onClose, onSaved }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone_number: "",
    position: "",
    company_id: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (customer) {
      setForm({
        name: customer.name || "",
        email: customer.email || "",
        phone_number: customer.phone_number || "",
        position: customer.position || "",
        company_id: customer.company_id || "",
      });
    }
  }, [customer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await api.put(`/api/customers/${customer.id}`, form);
      setLoading(false);
      onSaved();
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to update customer");
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-2xl w-[700px] max-h-[90vh] overflow-y-auto shadow-xl">
        {/* HEADER */}
        <div className="flex justify-between items-center mb-6">
          <UiText variant="title" as="h2">Edit Contact</UiText>
          <button className="text-gray-500 hover:text-black" onClick={onClose}>
            <FaTimes size={24} />
          </button>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-800 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* NAME */}
          <div className="mb-5">
            <UiText variant="label" as="label" className="block mb-2">Name *</UiText>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Full name"
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* EMAIL */}
          <div className="mb-5">
            <UiText variant="label" as="label" className="block mb-2">Email *</UiText>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Email address"
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* PHONE */}
          <div className="mb-5">
            <UiText variant="label" as="label" className="block mb-2">Phone Number</UiText>
            <input
              type="tel"
              name="phone_number"
              value={form.phone_number}
              onChange={handleChange}
              placeholder="(555) 123-4567"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* POSITION */}
          <div className="mb-5">
            <UiText variant="label" as="label" className="block mb-2">Position</UiText>
            <input
              type="text"
              name="position"
              value={form.position}
              onChange={handleChange}
              placeholder="Job title"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* COMPANY */}
          <div className="mb-5">
            <UiText variant="label" as="label" className="block mb-2">Company *</UiText>
            <select
              name="company_id"
              value={form.company_id}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">Select a company</option>
              {companies.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.name}
                </option>
              ))}
            </select>
          </div>

          {/* BUTTONS */}
          <div className="flex gap-3 justify-end mt-8">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
            >
              {loading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
